import {ActionList} from '@primer/styled-react'

import type {Reaction, ReactionContent} from '../utils/ReactionGroups'
import {EMOJI_MAP} from '../utils/ReactionGroups'
import styles from './ReactionsMenuItem.module.css'

type ReactionsMenuItemProps = {
  onReact: (reaction: ReactionContent, viewerHasReacted: boolean) => void
  reaction: Reaction
}

export function ReactionsMenuItem({onReact, reaction}: ReactionsMenuItemProps) {
  const {content, viewerHasReacted} = reaction
  return (
    <ActionList.Item
      key={content}
      sx={{
        '&:hover': {
          backgroundColor: 'accent.emphasis',
        },
        backgroundColor: viewerHasReacted ? 'accent.subtle' : 'transparent',
      }}
      role="menuitemcheckbox"
      aria-checked={viewerHasReacted}
      onSelect={() => onReact(content, viewerHasReacted)}
      className={styles.ReactionsMenuOption}
    >
      {EMOJI_MAP[content]}
    </ActionList.Item>
  )
}
